export const UPLOADCARE_DIALOG_CSS_CLASS = '.uploadcare--dialog.uploadcare--dialog_status_active';
